
// Внешние плагины
import axios from 'axios';
import { JSONPath } from 'jsonpath-plus';
import {
	UarmArm,
	ListMetaItem,
	FilterMetaitem,
	CardMetaItem,
	IdName,
	UarmServerField,
	UarmListItem,
	UarmRecordResponse,
	UarmRecordSend,
} from '@uarmSrc/types';
import { UarmListTreeLevel } from '@uarmSrc/util-tree';

// Утилиты
import urlUtil from './util-url.js';
import metaUtil from './util-meta.js';
import journalUtil from './util-journal.js';
import formdataUtil from './util-formdata.js';
import filtermemUtil from './util-filtermem.js';
import preprocessUtil from './util-api-data-preprocess';
import { has, generateUUID, humanFileSize, isWizard, orderComparator, nameComparator, getFieldValue } from './utils.js'; //@utils

// Наши компоненты в том числе и InexFeedback
import * as custom_components from './components/';

// import { InexFeedback } from './components/InexFeedback/InexFeedback.vue';

import tip from '@uarmSrc/tip.vue';
import modal from '@uarmSrc/modal.vue';
import childNavMixin from './mixins/child-nav-mixin.js';

import Collapse from './UI/Collapse';

// Контролы, в том числе "двойные"
import ctrls from './controls/_index.js';
import datetime_double from './controls/datetime/datetime_double.vue';
import number_input_double from './controls/number_input_double.vue';

import ChartLoader from '@ooo-inex/charts-component';

const pageNumberStoragePrefix = 'pageNumber_arm_';
const sortNameStoragePrefix = 'sortName_arm_';
const sortDirStoragePrefix = 'sortDir_arm_';

// TODO вынести эти две константы в один внешний файл и для визарда и для арма
const fieldWithoutColumnPrefix = '_FIELD_WITHOUT_COLUMN-';
const fieldOnCrossTablePrefix = 'CROSSFIELD__';

let batchUploadQueue: any[] = [];
const CancelToken = axios.CancelToken;

export default {
	name: 'ArmViewListFilter',
	mixins: [
		childNavMixin, // миксин с childNav_pathArray и методами для перехода в дочерние/родительские АРМ
		urlUtil.mixin, // m_indicateFileDownload
		formdataUtil.mixin, // миксин с методами сабмита записей
	],
	props: {
		/**
		 * Можно передать арм_ид в пропсах и он будет иметь приоритет на тем что в route
		 */
		arm_id: {
			type: Number,
		},
		/**
		 * Можно передать айди записи и колонку связи для isMultipleArm
		 */
		item_id: {
			type: Number,
		},
		item_target_column: {
			type: String,
		},
		/**
		 * Для карточки АРМа у которого должен показаться список из дочерних армов isMultipleArm (у дочерних childMultipleArm)
		 */
		list_in_card: {
			type: Boolean,
			default: false,
		},
		/**
		 * Для всплывающего АРМ выбора: 'single' или 'multi' (одиночный/множественный). В нормальном арме undefined
		 */
		pick_type: {
			type: String,
			default: function () {
				return this.$route.query.pick_type;
			},
		},
		/**
		 * Для всплывающего АРМ выбора: список ранее выбранных записей
		 */
		picked_items: {},
		/**
		 * Для всплывающего АРМ выбора: объект, где ключ - имя поля (dbcolname) поля фильтра, а значение - натурально, значение поля фильтра, которое будет использовано, как изначальное и может быть отредактировано
		 */
		predefined_filter: {
			type: Object,
			default: () => ({}),
		},
		/**
		 * нажата кнопка "Применить" в родительском компоненте
		 */
		apply_flag: {
			type: Boolean,
			default: false,
		},
	},
	components: Object.assign(
		{
			...custom_components,

			tip,
			modal,
			Collapse,
			datetime_double,
			number_input_double,
			ChartLoader,
			vuestyle: {
				render: function (createElement) {
					return createElement('style', this.$slots.default);
				},
			},
		},
		ctrls,
	),
	data(): UarmListComponentDataType {
		// @ts-ignore
		return this._getInstanceData();
	},
	computed: {
		siteId() {
			return Number(this.$route.params.vpId);
		},
		groupUpdateFields() {
			const listMeta: ListMetaItem[] = this?.$data?.listMeta;
			return listMeta.filter((item) => item.ctrlParams.groupUpdateData);
		},
		isNotPopup() {
			return !this.pick_type;
		},
		isMultiPickPopup() {
			return this.pick_type === 'multi';
		},
		isPagingTypeNextBased() {
			return this.armMeta['pagingType'] === 'NEXT_BASED';
		},
		c_totalCountText() {
			return this.totalCount
				? `Показано <span data-test-id="arm_list_count">${this.totalCount
						.toLocaleString('en-US')
						.replace(/,/, ' ')}</span>`
				: '';
		},
		c_showPager() {
			return this.totalCount > this.c_pageSize && !this.armMeta.isTreeView && !this.isPagingTypeNextBased;
		},
		c_filterValuesMap() {
			// объект где ключом выступает имя колонки, а значением - значение поля
			return this.c_filterMetaExisting.reduce(function (dataObj, field) {
				dataObj[field.dbcolname] = field.value;
				return dataObj;
			}, {});
		},
		c_filterMetaExisting() {
			const filterMeta: FilterMetaitem[] = this.$data.filter.meta;
			return filterMeta.filter(function (el) {
				return !!el; //защита от null, см выше
			});
		},
		c_filterMetaExistingFilled() {
			const filterMeta: FilterMetaitem[] = this.$data.filter.meta;
			return filterMeta.filter((f) => {
				return (
					(Array.isArray(f.value) === false && !!f.value) ||
					(f.ctrlCode === 'dropdown' && f.value === null) ||
					(f.ctrlCode === 'flag' && f.value === false) ||
					(f.ctrlCode === 'flag' && f.value === null) ||
					(f.value && Array.isArray(f.value) && f.value.some((v) => !!v))
				);
			});
		},
		c_multiPickedItemsSorted() {
			// преобразовываем объект в массив и сортируем по алфавиту (PIRS2018-837)
			let obj = this.multiPickedItemsStateObj;
			// Object.entries в ИЕ не работает, так что вот
			return Object.keys(obj)
				.map(function (k) {
					return obj[k];
				})
				.sort(nameComparator);
		},
		c_pageSize() {
			// 666777 - число от балды, которое, однако, в кодовой базе больше не встречается
			return this.armMeta.isTreeView ? 666777 : this.armMeta.pageSize | 0;
		},
		c_loadingAny() {
			return this.loadingMeta || this.loadingDataEntire;
		},
		isDynamicFields() {
			return has(this.armMeta, 'isDynamicFields') && this.armMeta.isDynamicFields === true;
		},
		dynamicFieldGroups() {
			let groups = [];
			if (this.isDynamicFields) {
				const field = this.armMeta.fields.find(
					(f) => f.hasOwnProperty('isDynamicFieldGroup') && f.isDynamicFieldGroup === true,
				);
				if (field && has(field, 'dictionaries') && Array.isArray(field.dictionaries)) {
					const { dictionaries } = field;
					// groups = _.uniqBy(_.filter(dictionaries, 'id'), 'id')
					groups = dictionaries;
				}
			}

			return groups;
		},
		// Есть ли опция пакетной загрузки файлов
		isMultipleUpload() {
			return this.armMeta.isMultipleUpload === true;
		},
		// Возвращает список полей с контролом загрузки файлов
		fileUploadFields() {
			return this.armMeta.fields.filter((f) => has(f, 'card') && f.card['ctrlCode'] === 'file_upload');
		},
		// Возвращает поле, в котором задана пакетная загрузка файлов
		multipleUploadField() {
			// isMultipleUploadField - признак проставляет сам визард у первого поля с загрузкой файлов при пакетной загрузке
			if (this.isMultipleUpload) {
				let field = this.fileUploadFields.find(
					(f) =>
						has(f, 'card.ctrlParams.isMultipleUploadField') &&
						f['card']['ctrlParams']['isMultipleUploadField'] === true,
				);
				return field ? field : this.fileUploadFields.length ? this.fileUploadFields[0] : null;
			}

			return null;
		},
		preserveCardUpload() {
			return (
				this.multipleUploadField &&
				this.multipleUploadField.card &&
				this.multipleUploadField.card.ctrlParams &&
				this.multipleUploadField.card.ctrlParams.preserveCardUpload === true
			);
		},
		documentsData() {
			return this.multipleUpload.items.filter((item) => !item.remove);
		},
		uploadingDocumentsCount() {
			return this.documentsData.filter((item) => !item.error && !item.id && item.loading && item.uploading).length;
		},
		maxFileSizeMultipleUpload() {
			return this.multipleUpload.maxFileSize;
		},
		hasHideFilterFields() {
			return this.c_filterMetaExisting.some(
				(f) =>
					has(f, 'ctrlParams.isDefaultView') === false ||
					(has(f, 'ctrlParams.isDefaultView') && f.ctrlParams['isDefaultView'] === false),
			);
		},
		isLessFilter() {
			return Boolean(this.filter.less);
		},
		hasRemoveChboxStateObj() {
			const filtered = Object.keys(this.removeChboxStateObj)
				.filter((key) => !!this.removeChboxStateObj[key])
				.reduce((obj, key) => {
					return {
						...obj,
						[key]: this.removeChboxStateObj[key],
					};
				}, {});

			return Object.keys(filtered).length > 0;
		},
		isColorTableList() {
			return true;
			return (
				this.armMeta['colorTableList'] &&
				this.armMeta.colorTableList.hasOwnProperty('value') &&
				this.armMeta['colorTableList']['value'] === true
			);
		},
		hasChart() {
			return this.armMeta.chartsComponent?.enabled || false;
		},
		parentId() {
			const parentParamObj = this.childNav_pathArray.find((arm) => arm.armId === this.armId);
			// console.log('parentParamObj', parentParamObj.parentRecordId);
			if (parentParamObj?.parentRecordId) return parentParamObj.parentRecordId;
		},
		chartUrl() {
			let url = '/ru/page/' + this.armMeta.chartsComponent?.pageId;
			if (this.parentId) {
				url += '?id=' + this.parentId;
			} else if (this.item_id) {
				url += '?id=' + this.item_id;
			}
			return url;
		},
		chartStyle() {
			return 'margin: 20px 0;';
		},
		lineHeight() {
			return 350;
		},
		chartHeight() {
			return 350;
		},
	},
	watch: {
		apply_flag() {
			if (this.apply_flag && !this.isNotPopup) {
				this.multiPickedItems_apply();
			}
		},
	},
	mounted() {
		this._handleOnMount();

		if (!this.list_in_card) {
			this.$root.$on('open-popup-child-arm', (targetId, parentFields) => {
				this.modalChildArm.success = false;
				this.modalChildArm.targetId = targetId;
				this.modalChildArm.parentFields = parentFields;
				this.modalChildArm.show = true;
				this.modalChildArm.pending = true;
				const { specMode } = this.$route.params;

				// !!! по уму надо использовать urlUtil.getServiceUrl()
				const apiUrl = `${urlUtil.getDomain()}${urlUtil.getPath({ specMode })}${this.siteId}/${
					this.modalChildArm.armId
				}/data?${[
					`${this.modalChildArm.targetColumn}=${targetId}`,
					`page=1`,
					`pageSize=1`,
					`sortingField=id`,
					`sortingDirection=DESC`,
				].join('&')}`;

				axios
					.get(apiUrl)
					.then(({ data }) => {
						const primaryKeyValue = data.count ? data.records[0].primaryKeyValue : 0;

						this.modalChildArm.childRecordId = primaryKeyValue;
						this.modalChildArm.success = true;
					})
					.catch((err) => {
						console.error(err);
						this.modalChildArm.success = false;
						this.modalChildArm.pending = false;
					});
			});
		}

		// как бы есть событие e_reload уже
		this.$on('update:data', () => this._fetchData());
	},
	beforeDestroy() {
		if (!this.list_in_card) {
			this.$root.$off('open-popup-child-arm');
		}
	},
	destroyed() {
		this.doFetchDataCancel();
		this.destroyChildArm();
	},
	/**
	 * главная цель - чтобы смена siteId работала
	 * @param from
	 * @param to
	 * @param next
	 */
	beforeRouteUpdate(from, to, next) {
		next();

		Object.assign(this.$data, this._getInstanceData());
		window.scroll(0, 0);
		this._handleOnMount();
	},
	methods: {
		_getInstanceData(): UarmListComponentDataType {
			const armId = (this.arm_id || this.$route.params.armId) | 0;
			if (!armId) {
				throw new Error('armId is undefined');
			}

			let multiPickedItemsStateObj = {};
			if (this.picked_items instanceof Array) {
				for (let i = 0; i < this.picked_items.length; i++) {
					let pitem = this.picked_items[i];
					multiPickedItemsStateObj[pitem.id] = {
						name: pitem.name,
						ITEM_ID: pitem.id,
					};
				}
			}

			let predefinedFilterString = '';
			for (let k in this.predefined_filter) {
				predefinedFilterString += '&' + k + '=' + this.predefined_filter[k];
			}

			return {
				has,
				armId,
				armUUID: generateUUID(),
				isWizard,
				armMeta: {},
				errText: '',
				loadingMeta: true,
				loadingDataEntire: false, // загружаем список целиком (т.е. не догрузка по кнопке Ещё)
				paging_inProcess: false, // дозагружаем данные и рендерим в конце списка
				nothingFound: false,
				showEditBtn: false,
				listItems: [],
				listMeta: [],
				sortingFieldName: '',
				sortingDirAsc: '',
				pageNumber: 1, // номер страницы
				loadNext_showBtn: false,
				_fetchDataCancel: undefined, // название начинается с педали чтобы не вешалась реактивность
				manualsave_queue_data: {},
				manualsave_loading_items: {},
				removeChboxStateObj: {}, // объект выделенных чекбоксом удаления записей. Ключ - primaryKeyValue aka ITEM_ID
				multiPickedItemsStateObj, // объект мультивыбранных записей. Ключ - primaryKeyValue aka ITEM_ID
				treeViewLvl: {
					minFetched: 1,
					maxFetched: 2,
					maxPossible: 0,
				},
				totalCount: 0,
				childNav_pathArray: this.childNav_getPathArray(),
				predefinedFilterString,
				implicitRecords: [],
				multipleUpload: {
					items: [],
					loading: false,
					maxFileSize: 80000,
					queueInterval: null,
				},
				filter: {
					meta: [],
					less: false, // Уменьшенный вариант фильтра
					wasUsed: false, // Фильтр был использован
					collapse: false,
					queryWhenSubmitted: '?',
					settingModal: {
						value: false,
						meta: [],
					},
				},
				modalChildArm: {
					armId: null,
					targetColumn: null,
					show: false,
					pending: false,
					success: false,
					childRecordId: 0,
					targetId: 0,
				},
				fetchDataLastDate: new Date(),
				tableListRowColors: [],
			};
		},
		destroyChildArm() {
			this.modalChildArm.show = false;
			this.modalChildArm.pending = false;

			this.$nextTick(() => {
				this.modalChildArm.success = false;
				this.modalChildArm.targetId = 0;
				this.modalChildArm.childRecordId = 0;
			});
		},
		_handleOnMount() {
			this._fetchMeta()
				.then(() => {
					let queryString = this.getCurrentFilterQuery();

					const isNeedFillFilter = this.armMeta.isNeedFillFilter;
					if (isNeedFillFilter) {
						if (!isNeedFillFilter || (isNeedFillFilter && queryString === '') || (isNeedFillFilter && queryString)) {
							this.filterSubmit();
						}
					} else {
						this._fetchData().catch((e) => console.log(e));
					}
				})
				.catch((e) => console.log(e));
		},
		_fetchMeta() {
			return new Promise<void>((resolve, reject) => {
				this.loadingMeta = true;

				const params = {
					vpId: this.siteId,
					armId: this.armId,
					specMode: this.$route.params.specMode,
					parentArmId: undefined,
				};

				// Передаем ID родительского арма - PIRS-2-10938
				if (this.$route.query.parentArmId) {
					params.parentArmId = this.$route.query.parentArmId;
				}

				metaUtil
					.getItem(params)
					.then((armMeta: UarmArm) => {
						if (!armMeta) throw new Error('NO_ARM_META');

						this.armMeta = armMeta;
						const { id, caption, fields, isTreeView, isEditable } = armMeta;

						const modalChildArmMeta = this.armMeta.childArms.find(({ openInPopup }) => openInPopup);
						if (modalChildArmMeta) {
							this.modalChildArm.armId = modalChildArmMeta.armId;
							this.modalChildArm.targetColumn = modalChildArmMeta.targetColumn;
						}

						/**
						 * Здесь если у АРМ есть признаки журналирования, в его armMeta.childArms добавляются фиктивные дочерние АРМ
						 */
						journalUtil.enrichArmMeta(armMeta);

						if (this.isNotPopup && window.UARM_CHANGE_PAGE_TITLE) {
							const domainArr = window.location.hostname.split('.');
							// для наших ПТК пишем в тайтл чтобы проще ориентироваться
							const ptkPrefix = domainArr.length === 4 ? domainArr[1] + ': ' : '';
							document.title = `${ptkPrefix} АРМ «${caption}» (${id})`;
						}

						const previousFilter = filtermemUtil.get(this.armId, this.siteId, this.childNav_pathArray);
						if (previousFilter) {
							this.filter.queryWhenSubmitted = previousFilter.queryString;

							const hasValues = Object.values(previousFilter.valuesMap).some((v) => !!v);
							if (hasValues) {
								this.filter.less = true;
								this.filter.wasUsed = true;
							}
						}

						let idColumnInList: boolean | string = false;
						let listHasStaticLinks = false;

						if (window.sessionStorage.getItem('CWP-27442')) {
							for (let i = 0; i < fields.length; i++) {
								let fieldMeta = fields[i];
								console.warn('дебаг-присвоение для CWP-27442. Удалить!');
								if (['date_publication', 'publish_type_id'].includes(fieldMeta.dbcolname)) {
									fieldMeta.list.combinedListColumnDbcolName = 'name';
								}
								if (['parent_id'].includes(fieldMeta.dbcolname)) {
									fieldMeta.list.combinedListColumnDbcolName = 'email';
								}
							}
						}

						for (let i = 0; i < fields.length; i++) {
							let fieldMeta = fields[i];

							const {
								name,
								order,
								required,
								dbcoltype,
								dbcolname,
								description,
								srv_options,
								dynamicFieldGroup,
								isDynamicFieldGroup,
							} = fieldMeta;

							/**
							 * Заполняем метаданные Фильтра
							 */
							if (fieldMeta.filter && fieldMeta.filter.ctrlCode) {
								const { ctrlCode, ctrlParams } = fieldMeta.filter;

								if (
									this.isDynamicFields &&
									has(fieldMeta, 'isDynamicFieldGroup') &&
									fieldMeta['isDynamicFieldGroup'] === true
								) {
									fieldMeta.srv_options = this.dynamicFieldGroups;
								}

								if (!ctrlParams.isInvisible) {
									const predefinedValue = this.$props?.predefined_filter?.[dbcolname];
									// console.log(`${dbcolname} predefinedValue=`, predefinedValue);
									let filterValue;
									if (previousFilter) {
										filterValue = previousFilter.valuesMap[dbcolname];
									} else if (predefinedValue) {
										filterValue = predefinedValue;
									}

									let filterMetaItem: FilterMetaitem = {
										isFilterField: true,
										value: filterValue,
										// поля, перечисленные ниже, одинаковые в filterMeta и listMeta
										ctrlCode,
										ctrlParams,
										dbcolname,
										name,
										order,
										required,
										dbcoltype,
										description,
										RANDOM_KEY: Math.floor(Math.random() * 1e7),
										srv_options,
										dynamicFieldGroup,
										isDynamicFieldGroup,
									};
									this.$data.filter.meta.push(filterMetaItem);
								}
							}

							/**
							 * Заполняем метаданные Списка
							 */

							if (fieldMeta.list && fieldMeta.list.ctrlCode) {
								const {
									ctrlCode: ctrlCodeMain,
									ctrlParams: ctrlParamsMain,
									combinedListColumnDbcolName: combinedListColumnDbcolNameMain,
								} = fieldMeta.list;

								if (ctrlCodeMain === 'text_static' && ctrlParamsMain.isLink) {
									listHasStaticLinks = true;
								}

								if (!ctrlParamsMain.isInvisible) {
									const listMetaItem = getListMetaItem(fieldMeta);
									this.listMeta.push(listMetaItem);
								}
								// тем, кто переживает, что функция объявляется в цикле: интерпретатор сам вынесет её наверх :)
								function getListMetaItem(fieldMeta2: UarmServerField): ListMetaItem {
									const { ctrlCode, ctrlParams, columnWidth } = fieldMeta2.list;
									const {
										name,
										order,
										required,
										dbcoltype,
										dbcolname,
										description,
										srv_options,
										dynamicFieldGroup,
										isDynamicFieldGroup,
									} = fieldMeta2;
									let titleAttr: string;
									let sortingIsOk = false;

									// не флаг потому что регистр может быть (ШТО???)
									if (dbcolname.toUpperCase() === 'ID') {
										idColumnInList = dbcolname;
									}

									const combinedListColumnMetaItems = armMeta.fields
										.filter(
											(fi) =>
												fi.list?.ctrlCode &&
												dbcolname.toUpperCase() === fi.list?.combinedListColumnDbcolName?.toUpperCase?.(),
										)
										.map(getListMetaItem);

									if (isTreeView) {
										// Древовидный АРМ не сортируем, потому что иначе вложенность перепутается - сейчас она достигается порядком, то есть на сервере сортируется по вычисляемой в БД колонке real_sort_order. Вообще при фильтрации надо бы отступы вложенности скрывать что ли, а то получается тоже фигня
										titleAttr = 'В древовидных АРМ сортировка запрещена';
									} else if (dbcolname.indexOf(fieldWithoutColumnPrefix) === 0) {
										titleAttr = 'Нельзя сортировать по полям без колонки';
									} else if (dbcolname.indexOf(fieldOnCrossTablePrefix) === 0) {
										titleAttr = 'Нельзя сортировать по полю с возможностью выбора множественных значений';
									} else if (fieldMeta2.lookup_table && armMeta.maintable.source !== fieldMeta2.lookup_table.source) {
										titleAttr = 'Нельзя сортировать, используйте фильтр';
									} else {
										sortingIsOk = true;
										titleAttr = `Нажмите, чтобы сортировать по колонке ${dbcolname}`;
									}

									const isMovedToCombinedListColumn =
										!!combinedListColumnDbcolNameMain &&
										combinedListColumnDbcolNameMain.toUpperCase() !== dbcolname.toUpperCase();

									const combinedListColNames = isMovedToCombinedListColumn
										? combinedListColumnMetaItems.map((cmbfi) => cmbfi.dbcolname).join(', ')
										: []; // проверка, чтобы избежать зацикливания

									const titleArrSuffix = combinedListColNames
										? `. В данной колонке таблицы выводятся значения следующих колонок: ${combinedListColNames} (в сортировке не участвуют)`
										: '';

									titleAttr += titleArrSuffix;

									let listMetaItem: ListMetaItem = {
										columnWidth,
										classAttr: sortingIsOk ? 'link-dotted' : '',
										titleAttr,
										sortingIsOk,
										// поля, перечисленные ниже, одинаковые в filterMeta и listMeta
										ctrlCode,
										ctrlParams,
										dbcolname,
										name,
										order,
										required,
										dbcoltype,
										description,
										srv_options,
										RANDOM_KEY: Math.floor(Math.random() * 1e7),
										dynamicFieldGroup,
										isDynamicFieldGroup,
										combinedListColumnMetaItems,
										isMovedToCombinedListColumn,
									};
									return listMetaItem;
								}
							}
						}

						this.listMeta.sort(orderComparator);
						this.$data.filter.meta.sort(orderComparator);

						/**
						 * если в списке нет ни одного контрола static с признаком isLink, кажем кнопку перехода в карточку
						 */
						this.showEditBtn = isEditable && listHasStaticLinks === false && this.isNotPopup;

						// Достаём из нескольких источников параметры сортировки
						if (isTreeView === false) {
							// древовидные не сортируем
							// опция 1. параметры сортировки из стореджа (выбранные ранее)
							this.sortingDirAsc = this.getSortingFieldDirAsc(this.armId);
							this.sortingFieldName = this.getSortingFieldName(this.armId);

							if (!this.sortingFieldName) {
								// опция 2. параметры сортировки из метаданных
								if (has(armMeta, 'defaultSorting') && armMeta.defaultSorting.enabled) {
									let field = this._getNormalisedSortingFieldName(armMeta.defaultSorting.field);

									if (field.indexOf(fieldWithoutColumnPrefix) < 0) {
										this.sortingFieldName = field;
										this.sortingDirAsc = this._getNormalisedSortingDir(armMeta.defaultSorting.dir);
									}
								} else if (idColumnInList) {
									// опция 3. Сортируем тупо по ID DESC (PIRS2018-3034)
									this.sortingDirAsc = false;
									this.sortingFieldName = idColumnInList;
								}
							}
						}

						// Получаем номер страницы
						if (!this.isPagingTypeNextBased) {
							this.pageNumber = this.getPageNumber();
						}

						if (this.c_filterMetaExisting.length) {
							// Получаем текущие настройки из локалсторейджа, и формируем отображение фильтров.
							const filterMetaSetting = this.$localStorage.get(`filterFields_${this.armId}`, [], Array);
							if (filterMetaSetting && filterMetaSetting.length) this.filter.settingModal.meta = filterMetaSetting;

							// Получаем текущие настройки из меты для пользователя, и формируем отображение фильтров.
							if (has(armMeta, 'settings.currentSettings.settings')) {
								try {
									const metaSetting = JSON.parse(armMeta.settings?.currentSettings?.settings);
									if (metaSetting && has(metaSetting, 'filter')) {
										const { filter } = metaSetting;
										if (Array.isArray(filter) && filter.length) {
											this.filter.settingModal.meta = filter;
										}
									}
								} catch (e) {
									console.log(e);
								}
							}

							// Применяем настройки фильтра.
							if (this.filter.settingModal.meta && this.filter.settingModal.meta.length) {
								this._handleApplySettingFilter();
							} else {
								// Если у АРМ нету полей, которые отображаются по-умолчанию, то показываем все поля
								const count = this.c_filterMetaExisting.filter(
									(f) => has(f, 'ctrlParams.isDefaultView') && f.ctrlParams['isDefaultView'] === true,
								).length;
								if (count === 0) {
									this._handleClickSettingFilter(true).then(() => {
										this._handleApplySettingFilter();
									});
								}
							}
						}

						this.loadingMeta = false; // TODO перенести ниже в always

						resolve && resolve();
					})
					.catch((thrown) => {
						console.log(thrown);

						this.errText =
							thrown && thrown.toString ? thrown.toString() : `Ошибка получения метаданных АРМ ${this.armId}`;

						reject && reject(thrown);
					});
			});
		},
		getFetchDataUrl: function (opts: { onlyParentId?: number; isFilterSubmit?: boolean } = {}) {
			const armMeta: UarmArm = this.armMeta;
			const { isFilterSubmit, onlyParentId } = opts;
			// TODO переделать сбор apiUrl с работы со строками на объект
			// потому что уже эребор
			let apiUrl = urlUtil.getServiceUrl({
				vpId: this.siteId,
				armId: this.armId,
				methodName: 'data',
				context: 'CONTEXT_LIST',
				specMode: this.$route.params.specMode,
				addQuery: this.filter.queryWhenSubmitted + this.predefinedFilterString,
			});

			// добавляем "родительские" фильтры (айди родителя) к дочерним АРМ
			apiUrl = this.appendChildParams(apiUrl);

			// Параметры пролистовки (у деревянных АРМ игнорятся сервером)
			apiUrl += `&page=${this.pageNumber}&pageSize=${this.c_pageSize}`;

			// добавляем фильтрацию по tree_level для CWP-21449
			if (armMeta.isTreeViewByLevel) {
				const { treeViewLvl } = this.$data as UarmListComponentDataType;
				treeViewLvl.minFetched = 1;
				treeViewLvl.maxFetched = UarmListTreeLevel.getLevelValueWithDef(this.armId);
				// в случае сабмита фильтра (т.е. поиска) не добавляем в запрос ни tree_level ни id_path
				if (!isFilterSubmit) {
					// console.error(`!!!!!!!!!!!! написать коммент 2, почему так !!!!!!!!!!`)
					// treeViewLvl.maxFetched = UarmListTreeLevel.defaultTreeLevel;
					/* const idPath = UarmListTreeLevel.getIdPathValue(this.armId);
					if (idPath) {
						console.error(`!!!!!!!!!!!! написать коммент 2, почему так !!!!!!!!!!`)
						treeViewLvl.minFetched = 1;
						treeViewLvl.maxFetched = UarmListTreeLevel.defaultTreeLevel;
						//const idPathParam = '&id=' + idPath.split('!').filter(v=>v).join('&id=');
						///console.log(`isTreeViewByLevel. Фильтруем по id_path: ${idPath}, а в запросе - по id: ${idPathParam}`);
						//apiUrl += `&id_path=${idPathParam}`;
					} */
					// у корневых разделов в БД указан налл (возможно, только в тестовой таблице), поэтому ищем с пустой строкой, а не с единицей
					const treeLevelMinParam = treeViewLvl.minFetched === 1 ? '' : treeViewLvl.minFetched;
					const treeLevelParam = `&tree_level__MIN=${treeLevelMinParam}&tree_level__MAX=${treeViewLvl.maxFetched}`;
					console.log(`isTreeViewByLevel. Фильтруем по tree_level treeLevelParam: ${treeLevelParam}`);
					apiUrl += treeLevelParam;
					// console.warn('Meta.isTreeViewByLevel СОРТИРОВКА!!!');
					// apiUrl += `&sortingField=sort_order&sortingDirection=ASC`;
				}
			}

			// при частичной загрузке детей (isTreeViewByLevel)
			if (onlyParentId) {
				apiUrl += `&parent_id=${onlyParentId}`;
			}

			if (this.sortingFieldName) {
				const sortingDir = this.sortingDirAsc ? 'ASC' : 'DESC';
				apiUrl += '&sortingField=' + this.sortingFieldName + '&sortingDirection=' + sortingDir;
			}

			apiUrl += this.$route.query.domain_id ? '&domain_id=' + this.$route.query.domain_id : '';

			// Передаем ID родительского арма - PIRS-2-10938
			if (this.$route.query.parentArmId) {
				apiUrl += `${apiUrl.indexOf('?') > -1 ? '&' : '?'}parent_arm_id=${this.$route.query.parentArmId}`;
			}

			return apiUrl;
		},
		/**
		 * Получение списка записей АРМ (т.е. собственно данных)
		 */
		_fetchData(
			opts: { reloadOnlyKidsOfItem?: UarmListItem; calcItemHiddenFn?: () => void; isFilterSubmit?: boolean } = {},
		) {
			const armId: number = this.armId;
			const armMeta: UarmArm = this.armMeta;
			const { reloadOnlyKidsOfItem, isFilterSubmit } = opts;

			if (reloadOnlyKidsOfItem) {
				reloadOnlyKidsOfItem.ITEM_KIDS_IS_FETCHING = true;
			}

			/*  || isFilterSubmit */
			/* || !this.isPagingTypeNextBased && !this.paging_inProcess  && !reloadOnlyKidsOfItem ) {
				if (!this.isPagingTypeNextBased && !this.paging_inProcess && !reloadOnlyKidsOfItem) {
				this.listItems.length = 0; // очищаем список (сразу как только идёт запрос)
				this.loadingDataEntire = true;
				console.warn(`Глупый фильтр сработал! Чистим список и загружаем все данные... Не забыть дополнить условие!`);
			}
			*/
			/* else if (armMeta.isTreeView && !this.paging_inProcess) {
				this.listItems.length = 0; // очищаем список (сразу как только идёт запрос)
				this.loadingDataEntire = true;
			} */

			// назвали "глупый фильтр", коммент для поиска
			if (!(armMeta.isTreeView || reloadOnlyKidsOfItem)) {
			}

			// ПЛОСКИЕ АРМ + ДЕР ПРОСТЫЕ + ДЕР СЛОИСТЫЕ
			// #1 срабатывает с условием:
			// !this.isPagingTypeNextBased && !reloadOnlyKidsOfItem
			// (paging_inProcess с первого перехода на вторую страницу начинает быть true и остаётся true даже вернувшись)
			console.warn(
				`(#1 сразу как только идёт запрос!) стр. ${this.pageNumber} isPagingTypeNextBased=${
					this.isPagingTypeNextBased
				}, paging_inProcess=${this.paging_inProcess} , !!reloadOnlyKidsOfItem(pure bool val)=${!!reloadOnlyKidsOfItem}`,
			);
			if (!this.isPagingTypeNextBased && /* !this.paging_inProcess && */ !reloadOnlyKidsOfItem) {
				this.listItems.length = 0;
				this.loadingDataEntire = true;
				console.warn(
					`(#1 сразу как только идёт запрос!) СРАБОТАЛО ++++ Чистим очищаем список и ЗАГРУЖАЕМ все данные... Не забыть дополнить условие!`,
				);
			}

			this.removeChboxStateObj = {};
			this.manualsave_queue_data = {};

			// Отменяем предыдущий запрос, если есть токен отмены
			this.doFetchDataCancel();

			// Создаём токен отмены для текущего запроса
			// см. https://github.com/axios/axios#cancellation
			const cancelToken = new axios.CancelToken((c) => (this._fetchDataCancel = c));

			return new Promise<void>((resolve, reject) => {
				console.log(`перед getFetchDataUrl! item.ITEM_ID=${reloadOnlyKidsOfItem?.ITEM_ID} !!!!!!!!!!!!

				TODO
				1) выставить isTreeLevelArm и проверить дочерние АРМ навигации админки - не помешают ли префильтры И связь по родителю или по upmost_parent_id 77777702=>77777703
				2) не испортит ли в 888811 другие вызовы фетчДата условие в needRootLevel, не будет ли оно постоянно выполняться, как вариант меньшее зло удалять когда доходим до последнего в листайтеме, пожертвовав f5 3) проверить поиск (фильтр)
				4) в доках указать в списке статик, а в карточке что-то редактируемое чтобы тупо указать, даже неявно
				5) крутилка - проверить на ню, может есть
				6) кейс дочернего АРМ когда тыкаем в родительском АРМ в других детей. Значения уровня и id_path - решается просто: в условном goToChildArm сбрасываем ДЛЯ ДОЧЕРНЕГО тупо оба ключа чтобы как в первый раз
				7) в тестах числа записей поправить при возврате из карточки
				8) хотя бы один АРМ в который ходим фронты или аналитики выставить isTreeByLevel (не забыв про поля) чтобы получить фидбек не от ФЗ
				`);

				const idPathStored = UarmListTreeLevel.getIdPathValue(armMeta.id);
				// const needRootLevel = idPathStored?.split?.('!')?.filter?.(Boolean)?.findIndex?.(idPart => idPart === String(reloadOnlyKidsOfItem?.ITEM_ID)) === 0;
				// const needRootLevel = idPathStored && !reloadOnlyKidsOfItem?.ITEM_ID;
				const needRootLevel = armMeta.isTreeViewByLevel && !reloadOnlyKidsOfItem?.ITEM_ID;
				if (needRootLevel) {
					//console.log(`UarmListTreeLevel. needRootLevel=${needRootLevel}. Но НЕ Сбрасываем treeLevel сторедж`);
					console.log(`UarmListTreeLevel. Сбрасываем обнуляем treeLevel сторедж`);
					UarmListTreeLevel.setLevelValue(armMeta.id, UarmListTreeLevel.defaultTreeLevel);
				}
				const uarmApiListUrl = this.getFetchDataUrl({ onlyParentId: reloadOnlyKidsOfItem?.ITEM_ID, isFilterSubmit });

				axios
					.get(uarmApiListUrl, { cancelToken })
					.then((res) => {
						console.log(`>>>> get data ${res.data.records}`);
						const resData: UarmRecordResponse = res.data;
						this.totalCount = res.data.count; // поле отсутствует при isPagingTypeNextBased (PIRS2018-1895)
						const resItemsList: UarmRecordSend[] = res.data.records;
						this.loadNext_showBtn = this.isPagingTypeNextBased && resItemsList.length === this.c_pageSize; // для типа пролистовки "Кнопка Загрузить Ещё"

						this.$data.fetchDataLastDate = res.data.timestamp ? new Date(res.data.timestamp) : new Date();

						console.log(`>>>> process data ${resItemsList}`);
						for (let i = 0; i < resItemsList.length; i++) {
							let item = preprocessUtil(resItemsList[i]);

							const itemTreeLevel = item['tree_level'] as number;
							if (armMeta.isTreeView) {
								let newMaxTreeLevel: number;
								// для деревянных v2 (isTreeView + isTreeViewByLevel):
								// мы грузим не все уровни, поэтому можем только прикинуть, что есть ещё один
								if (armMeta.isTreeViewByLevel) {
									const itemIsMaxDepth = itemTreeLevel === this.$data.treeViewLvl.maxPossible;
									const itemHasKids = !!item['kid_count'];
									newMaxTreeLevel = itemIsMaxDepth && itemHasKids ? itemTreeLevel + 1 : itemTreeLevel;
									// newMaxTreeLevel = itemTreeLevel;
								}
								// для деревянных v1 (только isTreeView):
								// мы грузим сразу все уровни, поэтому макс уровень сразу ясен
								else {
									newMaxTreeLevel = itemTreeLevel;
								}
								this.$data.treeViewLvl.maxPossible = Math.max(this.$data.treeViewLvl.maxPossible, newMaxTreeLevel);

								// console.log(`armMeta.isTreeViewByLevel=`, armMeta.isTreeViewByLevel, `item.kid_count=`, item.kid_count, `findKids=`, resItemsList.find((rec) => getFieldValue(rec.fields, 'parent_id') === item.ITEM_ID));
								if (
									armMeta.isTreeViewByLevel &&
									item.kid_count &&
									!resItemsList.find((rec) => getFieldValue(rec.fields, 'parent_id') === item.ITEM_ID)
								) {
									item.ITEM_HAS_KIDS_TO_BE_FETCHED = true;
									// присваевается в _fetchData и в doCollapse
								}
							}

							if (reloadOnlyKidsOfItem) {
								const reloadOnlyKidsOfItemIndex = this.listItems.findIndex(
									(item) => item.ITEM_ID === reloadOnlyKidsOfItem.ITEM_ID,
								);
								reloadOnlyKidsOfItem.ITEM_KIDS_IS_FETCHING = false;
								// @ts-ignore
								//window.itemsToBe = window.itemsToBe || [];
								// @ts-ignore
								//window.itemsToBe.push(item);
								// @ts-ignore
								//window.listItems = this.listItems;

								const newPosToInsertKids = reloadOnlyKidsOfItemIndex + i + 1;
								// если без учёта i позиции, то сортировка по real_sort_order исчезает, но она должна быть
								// console.log(`Всовываем пришедшего отдельно ребенка`, newPosToInsertKids, `ребенок=`, item);
								if (reloadOnlyKidsOfItemIndex !== -1) {
									this.listItems.splice(newPosToInsertKids, 0, item);
									reloadOnlyKidsOfItem.ITEM_KIDS_COLLAPSED = false;
									// opts.calcItemHiddenFn?.();
								}
								console.log(`>>> item on position ${newPosToInsertKids}`);

								// console.warn(
								// 	`(#2 уже когда пришёл ответ! в процессе итераций) стр. ${this.pageNumber} isPagingTypeNextBased=${
								// 		this.isPagingTypeNextBased
								// 	}, paging_inProcess=${
								// 		this.paging_inProcess
								// 	} , !!reloadOnlyKidsOfItem(pure bool val)=${!!reloadOnlyKidsOfItem}`,
								// );
								if (!this.isPagingTypeNextBased && !this.paging_inProcess && reloadOnlyKidsOfItem) {
									//this.$nextTick(() => {
									// nextTick - чтобы если несколько записей пришло
									/* console.warn(`(#2 уже когда пришёл ответ! в процессе итераций) СРАБОТАЛО ++++ Чистим очищаем список  и РИСУЕМ все данные...`) */
									// this.loadingDataEntire = true; - это загрузка данных с нуля
									//})
								}
							} else {
								this.listItems.push(item);
							}
						}

						// console.warn(
						// 	`(#3 уже когда пришёл ответ! после итераций) стр. ${this.pageNumber} isPagingTypeNextBased=${
						// 		this.isPagingTypeNextBased
						// 	}, paging_inProcess=${
						// 		this.paging_inProcess
						// 	} , !!reloadOnlyKidsOfItem(pure bool val)=${!!reloadOnlyKidsOfItem}`,
						// );
						// if (!this.isPagingTypeNextBased && !this.paging_inProcess && !reloadOnlyKidsOfItem) {
						// 	/* console.warn(`(#3 уже когда пришёл ответ! после итераций) СРАБОТАЛО++++ Чистим очищаем список (#3 уже когда пришёл ответ! после итераций) и РИСУЕМ все данные...`)
						// 	this.listItems.length = 0;
						// 	this.loadingDataEntire = true;// - это загрузка данных с нуля */
						// }

						if (this.list_in_card) {
							this.$emit('change');
						}

						this.nothingFound = !this.paging_inProcess && this.listItems.length === 0;
						this.implicitRecords = res.data.implicitRecords || [];

						resolve && resolve();
					})
					.catch((thrown) => {
						// ахтунг! в p_list.vue и p_card.vue находятся одинаковые обработчики ошибок запроса данных (плюс аналогичный - в util-meta.js)
						console.log(thrown);
						if (axios.isCancel(thrown)) {
							console.log('Axios request canceled', thrown.message);
						} else {
							let thrownMsg;
							let humanErrString = '[HUMAN_ERROR]';

							if (thrown && thrown.response) {
								const status = thrown.response.status;
								if (status === 401) {
									document.dispatchEvent(new Event('need-auth'));
									// cms-app слушает это событие и перезагружает страницу, чтобы появилась форма авторизации
								}
								if (status === 403) {
									if (window.UARM_AUTH_CHECK) {
										window.UARM_AUTH_CHECK(true);
									}
									thrownMsg = 'Ошибка доступа к АРМ № ' + armId + ' (код 403)';
								} else if (status === 404) {
									thrownMsg = 'Данные АРМ № ' + armId + ' не найдены';
								} else {
									this.$localStorage.set(sortNameStoragePrefix + this.armId, 'id');
									thrownMsg =
										'Ошибка ' + status + '. \n' + ((thrown.response.data && thrown.response.data.message) || '');
								}
							} else if (thrown.message && thrown.message.indexOf(humanErrString) === 0) {
								// для эксепшенов которые содержат текст кот надо показать
								thrownMsg = thrown.message.replace(humanErrString, '');
							} else {
								thrownMsg = 'Ошибка получения метаданных АРМ';
							}

							const userLogin = window.PAGEDATA?.login;
							if (userLogin) {
								thrownMsg += `\nЛогин: ${userLogin}`;
							}
							const rid = thrown?.response?.data?.rid || thrown?.rid || '<none>';
							if (rid) {
								thrownMsg += `\nИдентификатор запроса: ${rid}`;
							}

							this.errText = thrownMsg;

							reject && reject();
						}
					})
					.then(() => {
						this.paging_inProcess = false;
						this.loadingDataEntire = false;

						if (this.isColorTableList) {
							this.getColorTableList();
						}

						// https://jira.oooinex.ru/browse/PIRS2018-3408
						if (this.listItems.length === 0 && this.totalCount > 0 && this.pageNumber > 1) {
							this.setPageNumberAndFetch(1);
							console.log(
								'Ранее сохраненный номер страницы превышает количество полученных записей. Переключаемся на первую страницу.',
							);
						}
					})
					.then(() => {
						/* const idPathStored = UarmListTreeLevel.getIdPathValue(armId);
						console.error(`!!!!!!!!!!!! написать коммент 4, почему так !!!!!!!!!!`)
						if (idPathStored?.split('!').filter(Boolean).includes?.(String(item.ITEM_ID))) {
							this._fetchData()
						} */
					});
			});
		},
		getColorTableList() {
			let tableListRowColors: any[] = [];

			if (
				this.isColorTableList &&
				this.armMeta['colorTableList'] &&
				this.armMeta.colorTableList.hasOwnProperty('colors') &&
				Array.isArray(this.armMeta['colorTableList']['colors'])
			) {
				const json = { list: { items: this.listItems } };
				const colors = this.armMeta['colorTableList']['colors'];

				colors.forEach(({ rule, color }) => {
					if (rule && color) {
						const path = `$..items[?(${rule})]`;
						const result = JSONPath({ path, json });
						tableListRowColors.push({
							color,
							items: result.map((r) => r.id),
						});
					}
				});
			}

			this.$data.tableListRowColors = tableListRowColors;
		},
		getFieldName(colName) {
			return this.armMeta.fields.find(({ dbcolname }) => dbcolname === colName).name;
		},
		getImplicitValue(record, fieldName) {
			const { value } = record.fields.find(({ fieldId }) => fieldId === fieldName);

			// PIRS-2-10996 - есть ли значение в списке групп доступа
			const targetAccessValue =
				this.armMeta.rowAccess.groups.find(({ id }) => {
					return id === value;
				}) || {};
			if (targetAccessValue.name) {
				// PIRS-2-10996 - если значение соответствует группе доступа, выводим сюда название группы доступа
				return targetAccessValue.name;
			}

			return value;
		},
		/**
		 * Три вида сохранения записи:
		 * - карточка: p_card.vue
		 * - список: поэлементное сохранение (дефолтное, по изменению контрола) p_list.vue
		 * - список: общее сохранения (с чекбоксами, по нажатию кнопки) ListItem.vue
		 */
		manualsave_apply: function () {
			var vm = this;
			// архитектура такая, что закинуть всё в один аякс не получится :( пока так
			// впрочем если сохранять одним аяксом то ошибки будет разбирать трудно, лучше уж атомарно
			for (var recordId in vm.$data.manualsave_queue_data) {
				(function (submitArgument) {
					var recordIdClosured = submitArgument.recordId;

					// в submitArgument.successCallback зеленое сообщение, задается в list-item.vue
					// дописываем в него своё действие (эх, жаль не промис)
					submitArgument._successCallbackBase = submitArgument.successCallback;
					submitArgument.successCallback = function () {
						vm.$delete(vm.$data.manualsave_queue_data, recordIdClosured);
						submitArgument._successCallbackBase();
					};

					// тупо по очереди отправляем это добро
					submitArgument._listItemComponentRef.formdataUtil_doSubmit(submitArgument);
				})(vm.$data.manualsave_queue_data[recordId]);
			}
		},
		/**
		 * Простановка на очередь
		 * recordId передается всегда
		 * submitArgument опционален (передается когда чекбокс чекнут)
		 * @param recordId
		 * @param submitArgument
		 */
		manualsave_onQueueUpdate: function (recordId, submitArgument) {
			if (submitArgument) {
				this.$set(this.$data.manualsave_queue_data, recordId, submitArgument); // сет потому что Vue cannot detect property addition or deletion
			} else {
				this.$delete(this.$data.manualsave_queue_data, recordId);
			}
		},
		/**
		 * Хулиганский коллапс-экспанд: иду вниз по списку и скрываю строки пока не встречу равный либо меньший tree_level
		 * @param clickedItemIndex индекс элемента, на котором нажали шеврон
		 * @param itemKidsCollapsedNewValue признак того что детей надо свернуть
		 */
		doCollapseExpand_itemKids: function (clickedItemIndex: number, itemKidsCollapsedNewValue: boolean) {
			const $this = this;
			const listItems: UarmListItem[] = this.$data.listItems;
			const clickedItem = listItems[clickedItemIndex];
			const parentItemTreeLevel = clickedItem['tree_level'];

			const armMeta: UarmArm = this.$data.armMeta;
			// console.log(`doCollapseExpand_itemKids. itemKidsCollapsedNewValue=${itemKidsCollapsedNewValue}, clickedItem.ITEM_HAS_KIDS_TO_BE_FETCHED=${clickedItem.ITEM_HAS_KIDS_TO_BE_FETCHED}`);
			/** Вот тут логическая нестыковка: itemKidsCollapsedNewValue === true но притом в итоге они будут развёрнуты! И всё работает правильно. Нет времени разбираться :( */
			if (armMeta.isTreeViewByLevel && itemKidsCollapsedNewValue === true && clickedItem.ITEM_HAS_KIDS_TO_BE_FETCHED) {
				console.log(
					`По клику на шеврон: загружаем только непосредственных (!) детей записи ID=${clickedItem.id}, затем разворачиваем`,
				);
				// отсортированных по sort_order asc
				// инкрементим загружаемый уровень дерева
				// виден потенцильный баг (инкрементим getLevelValue() а надо this.$props.item.tree_level)
				// но лучше не трогать!
				UarmListTreeLevel.setLevelValue(this.armId, -1); // this.$props.item.tree_level
				// console.log('clickedItem was clicked, save id_path?', clickedItem.id_path + '0!');
				// откроет только первый уровень, а дальше переопределит и всё..
				// UarmListTreeLevel.setIdPathValue(this.armId, clickedItem.id_path + '0!');
				$this._fetchData({
					reloadOnlyKidsOfItem: clickedItem,
					calcItemHiddenFn: calcItemHiddenFn.call(this, clickedItemIndex, itemKidsCollapsedNewValue),
				});
				clickedItem.ITEM_HAS_KIDS_TO_BE_FETCHED = false; // по уму надо при успешной загрузке, но заморока
			} else {
				console.log(
					`По клику на шеврон: ${
						itemKidsCollapsedNewValue ? 'сворачиваем' : 'разворачиваем'
					} всех загруженных (не только непосредственных!) детей записи ID=${clickedItem.id}`,
				);
				calcItemHiddenFn.call(this, clickedItemIndex, itemKidsCollapsedNewValue);
			}

			function calcItemHiddenFn(clickedItemIndex: number, itemKidsCollapsedNewValue: boolean) {
				const $this = this;
				const listItems: UarmListItem[] = this.$data.listItems;
				const clickedItem = listItems[clickedItemIndex];
				const parentItemTreeLevel = clickedItem['tree_level'];
				clickedItem.ITEM_KIDS_COLLAPSED = itemKidsCollapsedNewValue;

				/* if (armMeta.isTreeViewByLevel && itemKidsCollapsedNewValue === true && clickedItem.ITEM_HAS_KIDS_TO_BE_FETCHED) {
					clickedItem.ITEM_HAS_KIDS_TO_BE_FETCHED = false;
				} */

				console.log(`calcItemHiddenFn. this=-`, this);
				for (let i = clickedItemIndex + 1; i < listItems.length; i++) {
					const item = listItems[i];
					if (item['tree_level'] > parentItemTreeLevel) {
						item.ITEM_IS_HIDDEN_BY_PARENT_COLLAPSE = itemKidsCollapsedNewValue;
						// this.$refs.listItemsRef[i].EXT_isHiddenByParentCollapse = itemKidsCollapsedNewValue;
					} else {
						break;
					}
				}
			}
			// this.$refs.listItemsRef[index];
		},
		/**
		 * Скрываем все записи, уровень которых больше указанного
		 * @param maxLevel записи с бОльшим значением tree_level будут скрыты
		 */
		doCollapse_maxLevel: function (maxLevel: number) {
			for (var i = 0; i < this.$refs.listItemsRef.length; i++) {
				const itemComp = this.$refs.listItemsRef[i];
				const itemData: UarmListItem = this.$data.listItems[i];
				const currLevel = itemData['tree_level'] as number;

				if (currLevel < maxLevel) {
					itemData.ITEM_IS_HIDDEN_BY_PARENT_COLLAPSE = false;
					//itemComp.$data.EXT_isHiddenByParentCollapse = false;
					itemData.ITEM_KIDS_COLLAPSED = false;
					//itemComp.$data.EXT_treeChildrenCollapsed = false;
				}

				if (currLevel === maxLevel) {
					itemData.ITEM_IS_HIDDEN_BY_PARENT_COLLAPSE = false;
					//itemComp.$data.EXT_isHiddenByParentCollapse = false;
					itemData.ITEM_KIDS_COLLAPSED = true;
					//itemComp.$data.EXT_treeChildrenCollapsed = true;
				}

				if (currLevel > maxLevel) {
					itemData.ITEM_IS_HIDDEN_BY_PARENT_COLLAPSE = true;
					//itemComp.$data.EXT_isHiddenByParentCollapse = true;
					itemData.ITEM_KIDS_COLLAPSED = true;
					//itemComp.$data.EXT_isHiddenByParentCollapse = true;
				}
			}
		},
		record_deleted(index) {
			this.listItems.splice(index, 1);
			if (this.listItems.length === 0) {
				this.nothingFound = true;
			}
		},
		loadNext_increment() {
			this.setPageNumberAndFetch(this.pageNumber + 1);
		},
		setPageNumberAndFetch(newPageNumber) {
			this.paging_inProcess = true;
			this.setPageNumber(newPageNumber);
			this._fetchData();
		},
		/**
		 * Для поиска по диапазону (дат или чисел) в фильтре подменяем код контрола
		 * @param f {Object}
		 * @returns {*}
		 */
		getFilterControlComponent(f) {
			let code;

			if (f.ctrlCode === 'datetime' && f.ctrlParams.isRange) {
				code = 'datetime_double';
			} else if (f.ctrlCode === 'number_input' && f.ctrlParams.isRange) {
				code = 'number_input_double';
			} else {
				code = f.ctrlCode;
			}

			return code;
		},
		/**
		 * добавляем данные для фильтрации по айди родительской записи (в случае если текущий арм дочерний)
		 * и айди текущего арма (в случае журналирования)
		 * @param apiUrl {string}
		 * @returns {string}
		 */
		appendChildParams(apiUrl) {
			const childPath = this.childNav_pathArray;

			// узнает относиться ли АРМ к типу isMultipleArm, если да то далее делаем поиск для дочернего арма нужный айди
			const listInCardTail = '&' + this.item_target_column + '=' + encodeURIComponent(this.item_id);

			if (childPath.length && this.isNotPopup) {
				// проверка на то что это не всплываюшее окно выбора потому что иначе PIRS2018-889
				let curChildParamObj = childPath[childPath.length - 1];
				let parentParamObj = childPath[childPath.length - 2];

				if (this.list_in_card) {
					apiUrl += listInCardTail;
				} else {
					// добавляем айди родительской записи для фильтрации
					apiUrl += `&${curChildParamObj.targetColumn}=${encodeURIComponent(curChildParamObj.parentRecordId)}`;
					// добавляем дополнительные поля для фильтрации (например, CWP-20568)
					if (curChildParamObj.parentExtraColumns) {
						const extraParamsToSet = this.childNav_getExtraParamsToSet();
						if (extraParamsToSet) {
							apiUrl += `&${extraParamsToSet}`;
						}
					}
				}

				if (journalUtil.armIdIsJournal(this.armId)) {
					apiUrl += '&arm_id=' + encodeURIComponent(parentParamObj.armId);
				}
			} else if (this.list_in_card) {
				apiUrl += listInCardTail;
			}

			return apiUrl;
		},
		/**
		 * Документация здесь:
		 * http://172.22.2.36:8080/swagger-ui.html#/resource-controller
		 * @param isReset {boolean}
		 */
		filterSubmit(isReset = false) {
			const filterMeta: FilterMetaitem[] = this.$data.filter.meta;
			// Опрашиваем контролы на валидность
			if (this.formdataUtil_checkFieldList(filterMeta) === false) {
				return;
			}

			let queryString = this.getCurrentFilterQuery();

			// Для АРМ где обязательно надо заполнять фильтр, проверяем это
			// TODO PIRS2018-1930
			if (this.armMeta.isNeedFillFilter && !queryString) {
				this.listItems.splice(0);
				this.totalCount = 0;
				this.$notify({
					type: 'warning',
					text: 'Пожалуйста, заполните хотя бы одно поле фильтра',
				});
				return;
			}

			this.setPageNumber(1);
			if (isReset === false) {
				// less что, блин :) это как однобуквенная переменная
				this.filter.less = true;
				this.filter.wasUsed = true;
			}

			queryString = '?' + queryString;
			const c_filterValuesMap = { ...this.c_filterValuesMap };

			this.filter.queryWhenSubmitted = queryString;

			this._fetchData({ isFilterSubmit: true }).then(() => {
				if (isReset === false) {
					filtermemUtil.set(this.armId, this.siteId, this.childNav_pathArray, queryString, c_filterValuesMap);
				}
			});
		},
		/**
		 * получение ТЕКУЩЕГО состояния фильтра
		 * в $data.filterQueryWhenSubmitted лежит состояние не момент сабмита формы
		 * @param bDisableEncoding
		 */
		getCurrentFilterQuery: function (bDisableEncoding) {
			var vm = this;
			var encode = bDisableEncoding ? (v) => v : encodeURIComponent;
			var query = '';
			for (var dbcolname in vm.c_filterValuesMap) {
				var fieldVal = vm.c_filterValuesMap[dbcolname];

				const filterMeta: FilterMetaitem[] = this.$data.filter.meta;

				var ctrlCode = vm.getFilterControlComponent(
					filterMeta.filter(function (f) {
						return f.dbcolname === dbcolname;
					})[0],
				); // потенциально могут быть баги если в фильтре одно поле выведено неск раз
				var isSearchEmpty = filterMeta.filter(function (f: FilterMetaitem) {
					return f.dbcolname === dbcolname;
				})[0].isSearchEmpty;

				if (isSearchEmpty) {
					query += dbcolname + '__EMPTY=true&';
				} else if (fieldVal && (ctrlCode === 'datetime_double' || ctrlCode === 'number_input_double')) {
					if (fieldVal[0]) {
						query += dbcolname + '__MIN' + '=' + encode(fieldVal[0]) + '&';
					}
					if (fieldVal[1]) {
						query += dbcolname + '__MAX' + '=' + encode(fieldVal[1]) + '&';
					}
				} else if (
					typeof fieldVal === 'string' ||
					typeof fieldVal === 'number' ||
					fieldVal === null ||
					typeof fieldVal === 'boolean'
				) {
					// налл - это например значение контрола Флаг "Пусто"
					if (fieldVal === '') {
						// пустые значения фильтра не передаем в запрос
						continue;
					}
					query += dbcolname + '=' + encode(fieldVal) + '&';
				} else if (fieldVal instanceof Array) {
					for (var j = 0; j < fieldVal.length; j++) {
						// ахтунг! поддерживается как массив айди [1,2,3] так и массив объектов [{id:1, name:'myname'}], поэтому в строке ниже есть логическое ИЛИ
						// массив объектов отдаёт контрол popup_picker в множественном режиме (multiPick===true)
						query += dbcolname + '=' + encode(fieldVal[j].id || fieldVal[j]) + '&';
					}
				} else if (typeof fieldVal === 'undefined') {
					// фильтр не биндится
				} else {
					console.error('Нет обработчика для', dbcolname, fieldVal);
				}
			}
			return query;
		},
		filterReset() {
			const filterMeta: FilterMetaitem[] = this.$data.filter.meta;
			for (let i = 0; i < filterMeta.length; i++) {
				let field = filterMeta[i];
				if (field) {
					this._handleResetFilterFiled(field);
				}
			}
			this.filter.less = false;
			this.filter.wasUsed = false;
			filtermemUtil.flush(this.armId, this.siteId, this.childNav_pathArray);
			this.$nextTick(() => this.filterSubmit(true)); // нексттик если не ошибаюсь из-за того что контрол датавремя (jquery ui datepicker) не успевал обновить данные
		},
		_handleResetFilterFiled(field: FilterMetaitem) {
			return new Promise<void>((resolve, reject) => {
				try {
					let datetimeClearSpecialValue = 'DATETIME_CLEARFIELD';

					// TODO: Пока временный фикс
					if (field.ctrlCode === 'datetime') {
						const ref = this.formdataUtil_getCtrlRef(field);

						if (!this.$refs[ref].length) {
							datetimeClearSpecialValue = '';
						}
					}
					if (field.isSearchEmpty) {
						field.isSearchEmpty = false;
					}

					if (field.ctrlParams.isRange) {
						if (field.ctrlCode === 'datetime') {
							field.value = [datetimeClearSpecialValue, datetimeClearSpecialValue];
						} else if (field.ctrlCode === 'number_input') {
							field.value = [undefined, undefined];
						}
					} else if (field.ctrlCode === 'datetime') {
						field.value = datetimeClearSpecialValue;
					} else if (typeof field.value === 'string') {
						field.value = '';
					} else if (field.ctrlCode === 'flag') {
						field.value = ''; // "не искать по этому полю" для флага
					} else {
						field.value = undefined;
					}

					resolve && resolve();
				} catch (e) {
					reject && reject(e);
				}
			});
		},
		_handleClickClearField(field) {
			this._handleResetFilterFiled(field)
				.then(() => {
					const hasFilledFields = this.c_filterMetaExistingFilled.length > 0;
					filtermemUtil.flush(this.armId, this.siteId, this.childNav_pathArray);

					if (hasFilledFields === false) {
						this.filter.less = false;
						this.filter.wasUsed = false;
					}
					this.$nextTick(() => this.filterSubmit(!hasFilledFields)); // нексттик если не ошибаюсь из-за того что контрол датавремя (jquery ui datepicker) не успевал обновить данные
				})
				.catch((e) => {
					console.log(e);
				});
		},
		_handleClickEditFilterField(field) {
			this._handleClickToggleLessFilter();

			setTimeout(() => {
				const ref = this.formdataUtil_getCtrlRef(field);
				if (ref && this.$refs[ref] && this.$refs[ref][0]) {
					const input = this.$refs[ref][0].$el.querySelector('input');
					if (input) {
						this.$nextTick(() => input.focus());
					}
				}
			}, 100);
		},
		doFetchDataCancel() {
			if (this._fetchDataCancel) {
				this._fetchDataCancel('Предыдущий запрос fetchData отменён'); // иначе PIRS-23151
			}
		},
		getPageNumber() {
			// const pageNumber = window.localStorage.getItem(pageNumberStoragePrefix + this.armId);
			const pageNumber = this.$localStorage.get(pageNumberStoragePrefix + this.armId, Number, 1);
			return Number(pageNumber) || 1;
		},
		setPageNumber(pageNumber) {
			this.pageNumber = pageNumber;
			// window.localStorage.setItem(pageNumberStoragePrefix + this.armId, pageNumber);
			this.$localStorage.set(pageNumberStoragePrefix + this.armId, pageNumber);
		},
		/**
		 *  Поле сортировки
		 * @param armId
		 * @returns {*}
		 */
		getSortingFieldName(armId) {
			// let field = window.localStorage.getItem(sortNameStoragePrefix + armId);
			const field = this.$localStorage.get(sortNameStoragePrefix + armId, String, null);
			return this._getNormalisedSortingFieldName(field);
		},
		_getNormalisedSortingFieldName(field) {
			let colname = '';
			const listMeta: ListMetaItem[] = this?.$data?.listMeta;
			if (field && listMeta) {
				let sortingField = listMeta.filter(function (el) {
					// защита от полей которые удалены в метаданных, но остались в сторедже
					return el.dbcolname === field;
				})[0];
				if (sortingField) {
					colname = sortingField.dbcolname;
				}
			}

			return colname;
		},
		setSortingFieldName(f) {
			this.sortingFieldName = f.dbcolname;
			// window.localStorage.setItem(sortNameStoragePrefix + this.$data.armId, f.dbcolname);
			this.$localStorage.set(sortNameStoragePrefix + this.armId, f.dbcolname);
		},
		/**
		 *  Направление сортировки
		 * @param armId
		 * @returns {boolean}
		 */
		getSortingFieldDirAsc(armId) {
			// const value = this.$localStorage.get(sortDirStoragePrefix + armId, Boolean, true)
			return window.localStorage.getItem(sortDirStoragePrefix + armId) === 'true';
		},
		_getNormalisedSortingDir(dir) {
			return dir.toUpperCase() === 'ASC';
		},
		setSortingFieldDirAsc(value) {
			this.sortingDirAsc = !!value;
			// window.localStorage.setItem(sortDirStoragePrefix + this.$data.armId, boo);
			this.$localStorage.set(sortDirStoragePrefix + this.armId, value);
		},
		clickSortingField(f) {
			if (f.sortingIsOk) {
				this.setPageNumber(1);
				if (this.sortingFieldIsCurrent(f)) {
					this.setSortingFieldDirAsc(!this.sortingDirAsc);
				} else {
					this.setSortingFieldName(f);
					this.setSortingFieldDirAsc(false);
				}

				this._fetchData();
			}
		},
		sortingFieldIsCurrent: function (f) {
			return this.sortingFieldName === f.dbcolname;
		},
		getSortingIconClass(f) {
			const suffix = this.sortingDirAsc ? 'top' : 'bottom';
			return 'glyphicon glyphicon-triangle-' + suffix + ' cursor-pointer';
		},
		ucFirst: function (str: string) {
			// форматирование компонента ФИО
			return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
		},
		/**
		 * без аргумента (объекта записи) открывает пустую карточку, т.е. создания записи
		 * если передан record то открывает карточку на редактирование этого самого record
		 * если передан и record и isTreeChildCreation то открывает карточку создания вложенной записи
		 */
		gotoCard(record?: UarmListItem, isTreeChildCreation?: boolean) {
			const armMeta: UarmArm = this.$data.armMeta;
			const { query } = this.$route;

			let recordId: number;
			let tree_parent_id: number;

			if (record) {
				// Создание вложенной записи
				if (isTreeChildCreation) {
					recordId = 0;
					tree_parent_id = record.ITEM_ID;
				}
				// Редактирование записи
				else {
					recordId = record.ITEM_ID;
					tree_parent_id = 0;
				}
				this.treeViewByLevel_set(record.tree_level, record.id_path);
			} else {
				// Создание записи
				recordId = 0;
				tree_parent_id = 0;
			}

			this.$router.push({
				name: 'ArmView_Card',
				params: {
					// Параметры запроса которые попадают в path
					armId: this.armId,
					vpId: this.siteId,
					recordId,
					specMode: this.$route.params.specMode,
				},
				/** Строка запроса в роутер, аналогично GET params. undefined значения в query не попадут */
				query: {
					pick_type: this.pick_type,
					tree_parent_id,
					parentArmId: query.parentArmId,
					childPathParam: query.childPathParam,
				},
			});
		},
		gotoArmEdit() {
			this.$router.push({
				name: 'armEdit',
				params: {
					armId: this.armId,
				},
			});
		},
		/**
		 * для АРМ с isTreeViewByLevel=true запоминаем в сессии значения treeLevel + idPath
		 * @param treeLevel
		 * @param idPath
		 */
		treeViewByLevel_set(treeLevel: number, idPath: string) {
			const armMeta: UarmArm = this.$data.armMeta;
			const item: UarmListItem = this.$props.item;
			if (armMeta.isTreeViewByLevel) {
				console.log(`UarmListTreeLevel. Создания записи нет, Сохраняем treeLevel и idPath. `);
				UarmListTreeLevel.setLevelValue(this.armId, treeLevel);
				UarmListTreeLevel.setIdPathValue(this.armId, idPath);
			}
		},
		goBack() {
			if (this.filter.wasUsed) {
				this.errText = '';
				this.$nextTick(() => this.filterReset());
			} else window.history.back();
		},
		customizePickedItem: function (item) {
			var vm = this;

			// PIRS2018-4798 - до сохранения карточки полное ФИО не выводится
			// здесь можно охватить и другие типичные случаи кастомизации отображения name на клиенте
			var firstName = item.first_name || item.firstname; // разные подходы к именованию колонок :(
			if (firstName) {
				var middleName = item.middle_name || item.middlename;
				var lastName = item.last_name || item.lastname || item.name;
				item.name = vm.ucFirst(lastName) + ' ' + vm.ucFirst(firstName);
				if (middleName) {
					item.name += ' ' + vm.ucFirst(middleName);
				}
			}
			if (item.summary_header_info && item.ITEM_RAW_VALUE && item.name.indexOf('<small>') != -1) {
				// составное поле, собранное по шаблону, содержащее тег small - доп.поле наследованных картинок/иконок/слогана в навигации.
				item.name = item.ITEM_RAW_VALUE;
			}
			return item;
		},
		onItemSelect: function (item) {
			var vm = this;
			// нажатие на кнопку Выбор (компонент list-item). Выбор может быть:

			// Множественный:
			// 		тогда мы "придерживаем" список выбранных записей для дальнейшего его пополнения или удаления из него
			//		посылаем выбранные записи "наверх" (компоненту popup_picker) по кнопке "Сохранить выбранные"
			if (vm.isMultiPickPopup) {
				if (vm.$data.multiPickedItemsStateObj[item.ITEM_ID]) {
					vm.multiPickedItems_remove(item); // при нажатии на ранее выбранных - удаляем выбор
				} else {
					vm.multiPickedItems_add(vm.customizePickedItem(item));
				}
			}
			// Единственный:
			//		посылаем выбранные записи "наверх" (компоненту popup_picker) сразу
			if (vm.pick_type === 'single') {
				vm.$emit('popup_select', vm.customizePickedItem(item));
			}
		},
		multiPickedItems_add: function (item) {
			this.$set(this.$data.multiPickedItemsStateObj, item.ITEM_ID, {
				ITEM_ID: item.ITEM_ID,
				name: item.name,
			});
		},
		multiPickedItems_remove: function (item) {
			this.$delete(this.$data.multiPickedItemsStateObj, item.ITEM_ID);
		},
		multiPickedItems_apply: function () {
			// отдаем "наверх" массив объектов [{id, name}] - такой же как отдает сервер для контрола popup_picker с признаком multiPick
			var vm = this;
			var ctrlValueArr: IdName[] = [];
			for (var id in vm.$data.multiPickedItemsStateObj) {
				ctrlValueArr.push({
					id: parseInt(id), // оно же ITEM_ID. parseInt потому что сервер не отловит строку, а БД не поймет
					name: vm.$data.multiPickedItemsStateObj[id].name,
				});
			}
			this.$emit('popup_select', ctrlValueArr);
		},
		removeChboxApply: function () {
			var vm = this;
			var armId = vm.$data.armId;

			var itemsToRemove: any[] = [];
			for (var pk in this.$data.removeChboxStateObj) {
				var v = this.$data.removeChboxStateObj[pk];
				if (v) {
					itemsToRemove.push(v); // itemsToRemove - массив вида [{ITEM_ID: 123, name: 'Моя запись'}]
				}
			}

			var confirmSubStringList: string[] = [];
			var records: any[] = [];
			for (var i = 0; i < itemsToRemove.length; i++) {
				// Просто вывести itemsToRemove[i].name нельзя: есть таблицы, где нет такой колонки
				confirmSubStringList.push((itemsToRemove[i].name || '') + ' (ID=' + itemsToRemove[i].ITEM_ID + ')');
				records.push({
					mode: 'delete',
					armId,
					primaryKeyValue: itemsToRemove[i].ITEM_ID,
					fields: [],
					armState: this.childNav_getArmState(this.listMeta, itemsToRemove[i]),
				});
			}

			var confirmSubString = confirmSubStringList.join(',\n');
			if (!itemsToRemove.length || !window.confirm('Подтвердите удаление следующих записей: \n' + confirmSubString)) {
				return;
			}

			vm.$data.filter.wasUsed = true;
			vm.$data.recordRemovePending = true;

			// !!! по уму надо использовать urlUtil.getServiceUrl()
			const { specMode } = this.$route.params;
			var apiUrl = urlUtil.getDomain() + urlUtil.getPath({ specMode }) + vm.siteId + '/' + armId + '/data';

			// Передаем ID родительского арма - PIRS-2-10938
			if (this.$route.query.parentArmId) {
				apiUrl += `${apiUrl.indexOf('?') > -1 ? '&' : '?'}parent_arm_id=${this.$route.query.parentArmId}`;
			}

			var formData = new FormData();
			formData.append(
				'jsonPayload',
				JSON.stringify({
					records,
				}),
			);

			axios
				.post(apiUrl, formData)
				.then(function (res) {
					var isOk = res.data && res.data.records && res.data.records.length !== 0;
					if (isOk) {
						// Успех
						vm.$notify({
							type: 'success',
							text: 'Успешно удалены записи:\n' + confirmSubString,
						});

						// Нерабочая конструкция! isPagingTypeNextBased - это компьютед!
						if (vm.$data.isPagingTypeNextBased) {
							vm.setPageNumber(1);
						}

						// после удаления записи возможно надо удалить из sessionStorage id_path, но можно и не удалять, т.к. записи нет и до неё не добраться.

						vm._fetchData();

						if (vm.armMeta.isAddable && vm.isMultipleUpload && vm.multipleUploadField) {
							vm.multipleUpload.items = [];
						}
						// vm.$emit('e_record_deleted');
					} else {
						console.log(res);
						// TODO reject promise
					}
				})
				.catch(function (xhr) {
					console.error(xhr);
					const srvError = xhr?.response?.data?.message;
					const isConstraint = srvError && srvError.indexOf('violates foreign key constraint') !== -1;
					let isTriggerError = srvError && srvError.match(/TRIGGER_ERROR_BEGIN/) != null;
					let srvErrorStartTextError = srvError && srvError.indexOf('TRIGGER_ERROR_BEGIN') + 19;
					let srvErrorEndTextError = srvError && srvError.indexOf('TRIGGER_ERROR_END');
					let shortTextError = srvError && srvError.slice(srvErrorStartTextError, srvErrorEndTextError);

					if (isConstraint) {
						vm.$notify('Данную запись невозможно удалить. Возможно, на неё ссылаются другие записи');
					} else {
						vm.$notify({
							type: 'error',
							duration: -1,
							text: 'Ошибка удаления записей:\n' + confirmSubString,
						});
						if (isTriggerError) {
							vm.errText = shortTextError || 'Ошибка удаления';
						} else {
							vm.errText = srvError || 'Ошибка удаления';
						}
					}
				})
				.then(function () {
					vm.$data.recordRemovePending = false;
				});
		},
		/**
		 * Когда у элемента списка (доч. комп.) ставится/снимается чекбокс "Удалить"
		 * @param item
		 * @param isChecked
		 */
		removeChboxOnToggle(item, isChecked) {
			const value = isChecked
				? {
						ITEM_ID: item.ITEM_ID,
						name: item.name,
				  }
				: null;

			this.$set(this.removeChboxStateObj, item.ITEM_ID, value);
		},
		/**
		 *  Когда всем элементам списка надо проставить/снять чекбокс "Удалить"
		 *  По уму здесь должно быть третье состояние чекбокса - когда в списке отмечен хотя бы один элемент
		 * @param isChecked
		 * @param evt
		 */
		removeChboxToggleAll(evt) {
			this.$refs.listItemsRef.forEach(function (el) {
				el.$data.EXT_removeChboxState = evt.target.checked; // ахтунг! изменение снаружи
			});
			// ахтунг! пользоваться EXT_removeChboxState можно
			// будет не сразу, а только после $nextTick
		},
		_handleSuccessLoaderService() {
			this._fetchData();
		},
		/** неочевидно, это Пакетная загрузка, TODO сделать префикс batch, а лучше вынести нафиг отсюда */
		_handleChangeMultipleUploadField(el) {
			let files = el.target.files || el.dataTransfer.files;
			if (!files.length) return;

			this.multipleUpload.loading = true;
			this._clearInputMultipleUploadField();

			Array.from(files).forEach((file, i) => {
				setTimeout(
					() => {
						this._createDocument(file);
					},
					(i < 2 ? 100 : 1000) + i * 200,
				);
			});
		},
		/** неочевидно, это Пакетная загрузка, TODO сделать префикс batch, а лучше вынести нафиг отсюда */
		_createDocument(file) {
			const { name: filename } = file;

			// @ts-ignore
			const extension = /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0].toUpperCase() : 'file';

			let item = {
				extension,
				show: true,
				hide: false,
				error: false,
				loading: true,
				remove: false,
				errorText: null,
				type: 'document',
				size: file.size,
				uploading: false,
				uid: generateUUID(),
				description: filename,
				source: CancelToken.source(),
			};

			this.multipleUpload.items.push(item);

			if (this.multipleUploadField) {
				const {
					card: { ctrlParams },
				} = this.multipleUploadField;

				const extListStr = ctrlParams.allowedExtensions;
				const maxSize =
					has(ctrlParams, 'maxSize') && ctrlParams.maxSize ? ctrlParams.maxSize : this.maxFileSizeMultipleUpload;
				const extList = extListStr ? extListStr.replace(/\s/g, '').toUpperCase().split(',') : [];

				if (extList.length) {
					if (extList.indexOf(extension) === -1) {
						this._handleUploadDocumentError(
							item.uid,
							`Файл размер имеет недопустимое расширение. Допустимые расширения: ${extList.join(', ')}`,
						);
						return false;
					}
				}

				const sizeKb = Math.ceil(file.size / 1000);
				if (sizeKb > maxSize) {
					this._handleUploadDocumentError(
						item.uid,
						`Размер файла ${humanFileSize(sizeKb)} и превышает масимально разрешенный ${humanFileSize(maxSize)}`,
					);
					return false;
				}

				this._handleUploadDocument(file, item);
			} else this._handleUploadDocumentError(item.uid, `Контрол для загрузки не назначен.`);
		},
		/** неочевидно, это Пакетная загрузка, TODO сделать префикс batch, а лучше вынести нафиг отсюда */
		_handleUploadDocument(file, item) {
			if (!file) return;

			batchUploadQueue.push({ file, item });

			this._handleQueueDocuments();
		},
		/** неочевидно, это Пакетная загрузка, TODO сделать префикс batch, а лучше вынести нафиг отсюда */
		_handleQueueDocuments() {
			if (this.multipleUpload.queueInterval) return;

			this.multipleUpload.queueInterval = setInterval(() => {
				if (!batchUploadQueue.length) {
					clearInterval(this.multipleUpload.queueInterval);
					this.multipleUpload.queueInterval = null;
					return false;
				}

				if (this.uploadingDocumentsCount < 2) {
					let { item, file } = batchUploadQueue.shift();

					item.uploading = true;

					this._handleQueueDocuments();
					this._handleUploadToServer(item, file)
						.then(({ uid, data }) => {
							this._handleUploadDocumentSuccess(uid, data);
						})
						.catch(({ uid, text }) => {
							this._handleUploadDocumentError(uid, text);
						});
				}
			}, 1000);
		},
		/** неочевидно, это Пакетная загрузка, TODO сделать префикс batch, а лучше вынести нафиг отсюда */
		_handleUploadToServer(item, file) {
			return new Promise((resolve, reject) => {
				const vm = this;
				let data = vm._generateFormDataUpload(item, file);

				// !!! по уму надо использовать urlUtil.getServiceUrl()
				const { specMode } = this.$route.params;
				const api = urlUtil.getDomain() + urlUtil.getPath({ specMode }) + vm.siteId + '/' + vm.armId + '/data';

				axios
					.post(api, data, {
						timeout: 120000,
						cancelToken: item.source.token,
						onUploadProgress(progressEvent) {
							vm._handleUploadDocumentProgress(item.uid, progressEvent);
						},
					})
					.then((response) => {
						const { data } = response;
						resolve && resolve({ uid: item.uid, data });
					})
					.catch((error) => {
						let text = null;
						const { response } = error;

						if (response) {
							const { data } = response;
							if (has(data, 'message')) {
								const { message } = data;
								text = message;
							}
						}

						reject && reject({ uid: item.uid, text });
						if (!response) throw new Error('Error upload document');
					});
			});
		},
		/** неочевидно, это Пакетная загрузка, TODO сделать префикс batch, а лучше вынести нафиг отсюда */
		_generateCardMeta(item) {
			let cardMeta: CardMetaItem[] = [];
			// это основное поле из родителя (фильтр по ПК)
			const parentFieldToSet = this.childNav_getParentFieldToSet();
			for (let k = 0; k < this.armMeta.fields.length; k++) {
				var fieldMeta = this.armMeta.fields[k];
				if (fieldMeta.card && fieldMeta.card.ctrlCode) {
					// по уму надо этот тип и в карточке и тут одной функцией генерить, эх :(
					// а так расхождения в составе полей появились
					const { dbcolname, name, description, srv_options, dbcoltype, required, order } = fieldMeta;
					const { ctrlCode, ctrlParams } = fieldMeta.card;
					const { defaultValue } = ctrlParams;

					let value;

					if (this.$route.query.tree_parent_id && dbcolname === 'parent_id') {
						value = this.$route.query.tree_parent_id;
					} else if (typeof defaultValue !== 'undefined' && defaultValue !== '') {
						value = defaultValue;
					} else if (parentFieldToSet.name === dbcolname) {
						value = parentFieldToSet.value;
					} // else if (parentExtraFieldToSet) {value = parentExtraFieldToSet.value}

					// Если есть значение name, то подставляем имя файла.
					if (dbcolname === 'name') {
						value = item.description;
					}

					// скрытый серверный контрол Пользователь
					var isHiddenCtrl_userData = ctrlCode === 'user_data' && !ctrlParams.bDisplayValue;
					// скрытый контрол Рассылка всегда
					var isHiddenCtrl_alwaysMailing = ctrlCode === 'mailing_init' && ctrlParams.alwaysMailing;

					if (!isHiddenCtrl_userData && !isHiddenCtrl_alwaysMailing && !ctrlParams.isInvisible) {
						cardMeta.push({
							name,
							description,
							ctrlParams: ctrlParams,
							srv_options, // коммент для поиска "srv_options переехали" PIRS2018-169
							dbcolname,
							dbcoltype,
							ctrlCode,
							value,
							required,
							order,
							RANDOM_KEY: Math.floor(Math.random() * 1e17),
						});
					}
				}
			}

			let fieldIndex = cardMeta.findIndex((f) => f.dbcolname === this.multipleUploadField['dbcolname']);
			if (fieldIndex) {
				this.$delete(cardMeta, fieldIndex);
				// this.$set(field, 'value', file)
			}

			return cardMeta;
		},
		/**
		 * неочевидно, это Пакетная загрузка, TODO сделать префикс batch, а лучше вынести нафиг отсюда
		 */
		_generateFormDataUpload(item, file) {
			let cardMeta = this._generateCardMeta(item);

			let data = {
				recordId: 0,
				mode: 'create',
				armId: this.armId,
				fieldList: cardMeta,
				parentFieldData: this.isNotPopup ? this.childNav_getParentFieldToSet() : {},
			};

			let formData = this.formdataUtil_getFormData(data);

			const { description } = item;

			// Не большой костыль, прходится самому подставлять значения, т.к. тут нету контролла факиически.
			formData.addField(this.multipleUploadField['dbcolname'], {
				fileId: 0,
				width: null,
				height: null,
				IS_REMOVE: false,
				FILE_PAYLOAD: file,
				IS_FILE_UPLOAD: true, // флаг-константа для util-formdata
				file_name: description,
				IS_PREVIOUSLY_UPLOADED: false,
			});

			return formData.setPayloadAndGetFormData();
		},
		_handleUploadDocumentProgress(uid, event) {
			this.$nextTick(() => {
				let index = this.multipleUpload.items.findIndex((item) => item.uid === uid);

				if (index < 0) return;

				let progress = Math.floor((event.loaded * 100) / event.total);

				this.$set(this.multipleUpload.items[index], 'progress', progress);
			});
		},
		_handleUploadDocumentSuccess(uid, data) {
			this.multipleUpload.loading = false;

			this.$nextTick(() => {
				let index = this.multipleUpload.items.findIndex((item) => item.uid === uid);

				if (index < 0) return;

				let item = this.multipleUpload.items[index];
				item.loading = false;
				item.progress = 100;

				console.log('Добавляем данные в список!', data);

				this.multipleUpload.items[index] = item;

				this._handleCheckQueueUploadDocument();
			});
		},
		_handleUploadDocumentError(uid, text) {
			this.multipleUpload.loading = false;

			this.$nextTick(() => {
				let index = this.multipleUpload.items.findIndex((item) => item.uid === uid);

				if (index < 0) return;

				let item = this.multipleUpload.items[index];
				item.loading = false;
				item.progress = 100;

				if (!item.show) return;

				item.error = true;

				if (text) item.errorText = text;
				this._handleCheckQueueUploadDocument();

				// Хотелось удалять файлы которые с ошибкой
				// setTimeout(() => this._handleUploadRemoveDocument(uid), 10000)
			});
		},
		_handleUploadRemoveDocument(uid, status = undefined) {
			this.multipleUpload.loading = false;

			this.$nextTick(() => {
				let index = this.multipleUpload.items.findIndex((item) => item.uid === uid);

				if (index < 0) return;

				if (typeof status !== 'undefined' && status === false) {
					this.multipleUpload.items[index].loading = false;

					return;
				}

				let item = this.multipleUpload.items[index];

				item.show = false;
				item.hide = true;
				setTimeout(() => {
					item.remove = true;
				}, 500);
			});
		},
		_handleCheckQueueUploadDocument() {
			setTimeout(() => {
				const hasQueueLoading = this.multipleUpload.items.filter((i) => i.loading === true);
				if (hasQueueLoading.length === 0) {
					this.setPageNumberAndFetch(1);
				}
			}, 500);
		},
		_clearInputMultipleUploadField() {
			const input = this.$refs.multipleUploadFieldInputFile;
			input.type = 'text';
			input.type = 'file';
		},
		/**/
		_handleClickToggleCollapseFilter() {
			this.filter.collapse = !this.filter.collapse;
		},
		_handleClickSettingFilter(value = false) {
			const filterMeta: FilterMetaitem[] = this.$data.filter.meta;
			return new Promise<void>((resolve, reject) => {
				try {
					this.filter.settingModal.meta = filterMeta.map((f) => {
						return {
							name: f.name,
							id: f.dbcolname,
							value: has(f, 'ctrlParams.isDefaultView') ? f.ctrlParams.isDefaultView : value,
						};
					});

					resolve && resolve();
				} catch (e) {
					reject && reject(e);
				}
			});
		},
		_handleClickSettingFilterOpenModal() {
			this._handleClickSettingFilter()
				.then(() => {
					this.filter.settingModal.value = true;
				})
				.catch((e) => console.log(e));
		},
		_handleClickSettingFilterCloseModal() {
			return new Promise<void>((resolve, reject) => {
				try {
					this.filter.settingModal.meta = [];
					this.filter.settingModal.value = false;
					resolve && resolve();
				} catch (e) {
					reject && reject(e);
				}
			});
		},
		_handleApplySettingFilter() {
			return new Promise<void>((resolve, reject) => {
				try {
					const { meta } = this.filter;
					const { meta: metaSetting } = this.filter.settingModal;

					meta.forEach((field, key) => {
						const index = metaSetting.map((i) => i['id']).indexOf(field['dbcolname']);
						if (index > -1) {
							const { value } = metaSetting[index];
							if (has(field, 'ctrlParams') === false) {
								this.$set(field, 'ctrlParams', {});
							}
							this.$set(field.ctrlParams, 'isDefaultView', value);

							// Если фильтр скрыли, но у него было значение, очищаем его из фильтра.
							if (value === false && field.value) {
								this._handleResetFilterFiled(field);
							}
						}
					});

					resolve && resolve(metaSetting);
				} catch (e) {
					reject && reject(e);
				}
			});
		},
		_handleClickApplySettingFilter() {
			this._handleApplySettingFilter()
				.then((meta) => {
					// Save localStorage and send to api
					this.$localStorage.set(`filterFields_${this.armId}`, JSON.stringify(meta));
					this._handleClickSettingFilterCloseModal();

					const domain = urlUtil.getDomain();
					axios
						.post(`${domain}/api/arm/${this.siteId}/${this.armId}/user/settings`, {
							settings: JSON.stringify({ filter: meta }),
						})
						.then((response) => {
							const {
								data: { result },
							} = response;
						})
						.catch((error) => {
							const {
								response: { data, status },
							} = error;
							throw new Error(`Error save settings user`);
						});
				})
				.catch((e) => console.log(e));
		},
		_handleClickToggleLessFilter() {
			this.filter.less = !this.filter.less;
		},
	},
};

type UarmListComponentDataType = {
	has: () => boolean;
	armId: number | string;
	armUUID: string;
	isWizard: boolean;
	armMeta: Record<string, any>;
	errText: string;
	loadingMeta: boolean;
	loadingDataEntire: boolean;
	paging_inProcess: boolean;
	nothingFound: boolean;
	showEditBtn: boolean;
	listItems: any[];
	listMeta: any[];
	sortingFieldName: string;
	sortingDirAsc: boolean | string;
	pageNumber: number;
	loadNext_showBtn: boolean;
	_fetchDataCancel: any | undefined;
	manualsave_queue_data: Record<string, any>;
	manualsave_loading_items: Record<string, any>;
	removeChboxStateObj: Record<string | number, boolean>;
	multiPickedItemsStateObj: Record<string | number, boolean>;
	treeViewLvl: {
		minFetched: number;
		maxFetched: number;
		maxPossible: number;
	};
	totalCount: number;
	childNav_pathArray: any[];
	predefinedFilterString: string;
	implicitRecords: any[];
	multipleUpload: {
		items: any[];
		loading: boolean;
		maxFileSize: number;
		queueInterval: any; //NodeJS.Timeout | null;
	};
	filter: {
		meta: any[];
		less: boolean;
		wasUsed: boolean;
		collapse: boolean;
		queryWhenSubmitted: string;
		settingModal: {
			value: boolean;
			meta: any[];
		};
	};
	modalChildArm: {
		armId: number | string | null;
		targetColumn: string | null;
		show: boolean;
		pending: boolean;
		success: boolean;
		childRecordId: number;
		targetId: number;
	};
	fetchDataLastDate: Date;
	tableListRowColors: any[];
};
